import { I11PERCHARVARI_State } from '@batical/types/src'

const I11PERCHARVARI: I11PERCHARVARI_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  perteCharg_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  in_pertechargenominal: 0.0,
  in_debitnominal: 0.0,
  in_nouveaudebit: 0.0,
  res_resistanceelement: 0.0,
  res_ouvellepertecharge: 0.0,
  mode: 'none',
  calcul_code: 'I11PERCHARVARI'
}

export default I11PERCHARVARI
